
import { useI18n } from "src/utils/lni18n";
import { useMemo, useState } from "react";
import EditThemeParts from "./EditThemeParts";
import EditThemeMeta from "./EditThemeMeta";
import { useParams } from "react-router-dom";
import { useAtom } from "jotai";
import { oneThemeAtom } from "../CourseService";


enum TabTypeInTheme {
    parts,
    meta
}


const EditTheme = () => {

    const { languageService: t } = useI18n();
    const [tabType, setTabType] = useState(TabTypeInTheme.parts);
    const { courseId, themeId } = useParams();


    const [theme] = useAtom(useMemo(() => oneThemeAtom(courseId ?? "", themeId ?? ""), [courseId, themeId]));

    if (!courseId || !themeId) {
        return null;
    }


    return (
        <>
            <h3>{t.getText("theme")}:&nbsp;&nbsp; {theme?.Name}</h3>

            <div className="mt-5 custom-tab-heading-list" >
                <button type="button" className={`${tabType === TabTypeInTheme.parts ? "active" : ""}`}
                    onClick={() => setTabType(TabTypeInTheme.parts)}>
                    {t.getText("courseparts.in.theme")}
                </button>

                <button type="button" className={`${tabType === TabTypeInTheme.meta ? "active" : ""}`}
                    onClick={() => setTabType(TabTypeInTheme.meta)}>
                    {t.getText("general.theme")}
                </button>

            </div>

            {tabType === TabTypeInTheme.parts && <EditThemeParts />}

            {tabType === TabTypeInTheme.meta && <EditThemeMeta />}


        </>
    )
}

export default EditTheme;
